import { create } from 'zustand';

const AUTH = () => ({ Authorization: `Bearer ${localStorage.getItem('auth_token')}` });

export const useEventStore = create((set, get) => ({
  events: {},    // { serverId: [event] }
  loading: false,

  fetchEvents: async (serverId) => {
    if (!serverId) return;
    if (serverId.startsWith('demo-')) {
      set(s => ({ events: { ...s.events, [serverId]: [
        { id: 'evt-1', title: 'Community Game Night', description: 'Weekly game night — all welcome!', type: 'voice', location: 'Gaming Lounge', startTime: new Date(Date.now() + 2 * 3600 * 1000).toISOString(), endTime: new Date(Date.now() + 4 * 3600 * 1000).toISOString(), rsvps: ['u1','u2','u3'], status: 'scheduled' },
        { id: 'evt-2', title: 'Dev Office Hours',     description: 'Ask the team anything. Stage Q&A.', type: 'stage', location: 'Stage', startTime: new Date(Date.now() + 26 * 3600 * 1000).toISOString(), endTime: new Date(Date.now() + 27 * 3600 * 1000).toISOString(), rsvps: ['u1'], status: 'scheduled' },
      ] } }));
      return;
    }
    set({ loading: true });
    try {
      const r = await fetch(`/api/servers/${serverId}/events`, { headers: AUTH() });
      const d = await r.json();
      set(s => ({ events: { ...s.events, [serverId]: d.events || [] }, loading: false }));
    } catch { set({ loading: false }); }
  },

  createEvent: async (serverId, payload) => {
    const r = await fetch(`/api/servers/${serverId}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...AUTH() },
      body: JSON.stringify(payload),
    });
    const d = await r.json();
    if (d.success) set(s => ({ events: { ...s.events, [serverId]: [...(s.events[serverId] || []), d.event] } }));
    return d.event;
  },

  updateEvent: async (serverId, eventId, payload) => {
    await fetch(`/api/servers/${serverId}/events/${eventId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', ...AUTH() },
      body: JSON.stringify(payload),
    });
    set(s => ({ events: { ...s.events, [serverId]: (s.events[serverId] || []).map(e => e.id === eventId ? { ...e, ...payload } : e) } }));
  },

  deleteEvent: async (serverId, eventId) => {
    await fetch(`/api/servers/${serverId}/events/${eventId}`, { method: 'DELETE', headers: AUTH() });
    set(s => ({ events: { ...s.events, [serverId]: (s.events[serverId] || []).filter(e => e.id !== eventId) } }));
  },

  rsvp: async (serverId, eventId, join = true) => {
    await fetch(`/api/servers/${serverId}/events/${eventId}/rsvp`, { method: join ? 'POST' : 'DELETE', headers: AUTH() });
    set(s => {
      const userId = localStorage.getItem('user_id') || 'me';
      return { events: { ...s.events, [serverId]: (s.events[serverId] || []).map(e => {
        if (e.id !== eventId) return e;
        const rsvps = join ? [...new Set([...(e.rsvps || []), userId])] : (e.rsvps || []).filter(id => id !== userId);
        return { ...e, rsvps };
      }) } };
    });
  },

  getServerEvents: (serverId) => get().events[serverId] || [],
}));
